import React, { Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { useUser } from "contexts/UserContext";
import ProtectedRoute from "routes/ProtectedRoute";

import modalComponents, { usePageTitle } from "routes/ModalMap";
import LazyFormWrapper from "pages/comuns/LazyFormWrapper";

const Start = React.lazy(() => import("pages/principal/ChronosStart"));
const Login = React.lazy(() => import("pages/principal/Login"));
const Presencia= React.lazy(() => import("pages/chronos/FrmPresencia"));
const Calendari= React.lazy(() => import("pages/chronos/FrmCalendari"));

const Home= React.lazy(() => import("pages/principal/Home"));

// Wrapper modal
const RouteModalWrapper = ({ children }) => (
  <div className="absolute top-0 left-0 right-0 h-[calc(100%-64px)] flex justify-center items-center bg-black/40 z-50">
    {children}
  </div>
);

const AppRoutes = () => {
  const { loadingUser } = useUser();
  const location = useLocation();
  const background = location.state?.background;

  usePageTitle();

  if (loadingUser) {
    return <div className="loading-screen">Cargando usuario...</div>;
  }

  // Renderizador lazy del formulario
  const LazyForm = ({ component: Component }) => (
    <Suspense>
      <Component />
    </Suspense>
  );

  return (
    <>
      <Suspense>
        {/* Rutas normales (base) */}
        <Routes location={background || location}>
     {/* LOGIN (solo aparece si NO hay terminal configurada) */}
            <Route path="/login" element={<Login />} />
 {/* START (solo aparece si hay terminal configurada pero NO usuario) */}
            <Route path="/start" element={<Start />} />

          {/* TODAS LAS RUTAS PASAN POR ProtectedRoute */}
          <Route element={<ProtectedRoute />}>

           
            {/* HOME por defecto */}
            <Route index element={<Navigate to="/home" replace />} />

            {/* RUTAS PRIVADAS */}
            <Route path="/home" element={<Home />} />
            <Route path="/users" element={<h2>Gestión de Usuarios</h2>} />
            <Route path="/consultas" element={<h2>Consultas</h2>} />
            <Route path="/presencia" element={<Presencia/>} />
            <Route path="/calendario" element={<Calendari/>} />

            {/* RUTAS DE FORMULARIOS (modal + versión normal) */}
            {Object.entries(modalComponents)
              .filter(([_, config]) => config.path)
              .map(([key, config]) => (
                <Route
                  key={key}
                  path={config.path.replace(/^\//, "")}
                  element={<LazyForm component={config.component} />}
                />
              ))}
          </Route>

          {/* fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>

      {/* RENDER MODAL */}
      {background &&
        Object.entries(modalComponents)
          .filter(([_, config]) => config.path && location.pathname === config.path)
          .map(([key, config]) => (
            <RouteModalWrapper key={key}>
              <LazyForm component={config.component} />
            </RouteModalWrapper>
          ))}
    </>
  );
};

export default AppRoutes;
